import { env } from 'common/env'
import { callBackend } from './fetch'

export class FinancialBlockApi {
  async unblockAdvertiser(advertiserId: number): Promise<void> {
    await callBackend(`${env.endpoint}/api/adv/${advertiserId}/payment-unblock`, { method: 'POST' })
  }

  async unblockAgency(agencyId: number): Promise<void> {
    await callBackend(`${env.endpoint}/api/agency/${agencyId}/payment-unblock`, { method: 'POST' })
  }
}

export const financialBlockApi = new FinancialBlockApi()
